<template>
  <form-wrap
    class="sign-in-form"
    @submit="customCreate"
  >
    <form-field-set :should-show-border="false">
      <text-input
        v-model="workspace"
        :error="fieldError('create', 'workspace')"
        :label="$t('c.signInForm.form.label.workspace')"
        name="workspace"
        direction="vertical"
      />
      <text-input
        v-model="email"
        :error="fieldError('create', 'email')"
        :label="$t('c.signInForm.form.label.email')"
        name="email"
        direction="vertical"
      />
      <text-input
        v-model="password"
        :error="fieldError('create', 'password')"
        :label="$t('c.signInForm.form.label.password')"
        name="password"
        direction="vertical"
        type="password"
      >
        <router-link
          v-t="'c.signInForm.form.label.passwordReset'"
          slot="addon"
          :to="{ name: 'PasswordResetPage' }"
          class="sign-in-form__password-reset-link"
        />
      </text-input>
    </form-field-set>

    <switch-input
      v-if="hasTermsAndCondition"
      v-model="agreeTermsAndConditions"
      :label-visible="false"
      :hint="termsAndCondition.notice"
      :true-label="$t('c.signInForm.form.label.hintTrue')"
      :false-label="$t('c.signInForm.form.label.hintFalse')"
      class="add-margin-top"
      name="notice"
    />

    <form-actions>
      <button-input
        v-t="'c.signInForm.form.action.submit'"
        :is-disabled="!isValid"
        type="submit"
      />
      <router-link
        v-t="'c.signInForm.form.action.signup'"
        v-if="false"
        :to="{ name: 'SignUpPage' }"
      />
    </form-actions>
  </form-wrap>
</template>

<script>
import FormMixin from '@/mixins/forms/Form'
import { mapActions, mapGetters } from 'vuex'
import isBlank from 'is-blank'

export default {
  name: 'SignInForm',
  mixins: [FormMixin],
  data () {
    return {
      agreeTermsAndConditions: false,
      termsAndConditions: [
        {
          workspace: 'db',
          notice: 'Bei der Nutzung von Endgeräten muss die geltende Konzernrichtlinie 114.0230A01 eingehalten werden. Insbesondere darf der Zugriff nicht von privaten Endgeräten erfolgen. Mit dem Schieben des Reglers nach Rechts bestätige ich, dass ich mich mit einem konzerneigenen Endgerät einlogge.'
        },
        {
          workspace: 'dbservice',
          notice: 'Bei der Nutzung von Endgeräten muss die geltende Konzernrichtlinie 114.0230A01 eingehalten werden. Insbesondere darf der Zugriff nicht von privaten Endgeräten erfolgen. Mit dem Schieben des Reglers nach Rechts bestätige ich, dass ich mich mit einem konzerneigenen Endgerät einlogge.'
        }
      ]
    }
  },
  computed: {
    ...mapGetters({
      fieldError: 'signInForm/fieldError'
    }),
    email: {
      get () { return this.$store.state.signInForm.form.email },
      set (value) { this.$store.dispatch('signInForm/setEmail', value) }
    },
    password: {
      get () { return this.$store.state.signInForm.form.password },
      set (value) { this.$store.dispatch('signInForm/setPassword', value) }
    },
    workspace: {
      get () { return this.$store.state.signInForm.form.workspace },
      set (value) {
        if (value == '') { this.agreeTermsAndConditions = false }
        this.$store.dispatch('signInForm/setWorkspace', value.toLowerCase() )
      }
    },
    isValid() {
      return !isBlank(this.workspace) && !isBlank(this.email) && !isBlank(this.password) && (this.agreeTermsAndConditions == this.hasTermsAndCondition)
    },
    termsAndCondition() {
      return this.termsAndConditions.find(entry => entry.workspace == this.workspace)
    },
    hasTermsAndCondition() {
      return this.termsAndCondition !== undefined
    }
  },
  methods: {
    ...mapActions({
      customCreate: 'signInForm/customCreate'
    })
  }
}
</script>

<style lang="sass">
.sign-in-form__password-reset-link
  font-size: 14px
  position: absolute
  right: 0
  top: -34px
</style>



// WEBPACK FOOTER //
// src/components/auth/SignInForm.vue